import { render, staticRenderFns } from "./AppSideEffectsAnnoyingStuff.vue?vue&type=template&id=44783360&scoped=true&"
import script from "./AppSideEffectsAnnoyingStuff.vue?vue&type=script&lang=js&"
export * from "./AppSideEffectsAnnoyingStuff.vue?vue&type=script&lang=js&"
import style0 from "./AppSideEffectsAnnoyingStuff.vue?vue&type=style&index=0&id=44783360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44783360",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
